export enum RpObjectLinkTypeEnum{

    OneToOne,
    OneToMany

}